// extracted by mini-css-extract-plugin
export default {"tabGroup":"_3WrS6ULmTLwgVjTCbKcsKJ"};